




















































import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapGetters, mapActions } from "vuex";

const headers: Header[] = [
  { title: "名称", key: "metadata.name", minWidth: 200 },
  { title: "状态", key: "", width: 120 },
  { title: "主机名称(IP)", key: "spec.nodeName", width: 200 },
  { title: "容器组IP", key: "", width: 150 },
  { title: "创建时间", key: "", width: 178 },
  { title: "操作", key: "", width: 118 }
];
export default Vue.extend({
  name: "Pod",
  props: {
    data: { type: Object },
    type: { type: String },
    projectId: { type: String }
  },
  data() {
    return {
      headers,
      loadType: "",
      // 翻页禁止参数
      disabled: false,
      monitorData: null as any,
      lineList: [
        { title: "CPU 负载(%)", name: "podCpuUsage" },
        { title: "内存使用量(MB)", name: "podMemoryUsage" },
        { title: "网络流出速率(bps)", name: "podNetBytesTransmitted" },
        { title: "网络流入速率(bps)", name: "podNetBytesReceived" }
      ],
      showMonitor: false
    };
  },
  computed: {
    ...mapState("PrjAppCom/Container", [
      "total",
      "hasNext",
      "pageNum",
      "loading"
    ]),
    ...mapGetters("PrjAppCom/Container", ["tableData"])
  },
  mounted() {
    this.getTable();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions("PrjAppCom/Container", ["getData", "pageTurn", "clear"]),
    getTable() {
      if (this.type === "无状态组件") {
        this.loadType = "Deployment";
      } else if (this.type === "有状态组件") {
        this.loadType = "StatefulSet";
      }
      this.getData({
        url: "/pod/list/project",
        append: `&projectId=${this.projectId}&loadType=${this.loadType}&app=${this.data.metadata.name}`
      });
    },
    monitor(data: any) {
      this.monitorData = data.metadata.name;
      this.showMonitor = true;
    },
    refush() {
      this.clear();
      this.getTable();
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    close() {
      this.showMonitor = false;
    }
  }
});
